import helpers, { hasBodyClass } from "../../js/helpers.js";
(hasBodyClass("product-template") || hasBodyClass("product-gift-card-template")) && import("../../js/prodify.js");

export function start() {}
